import { useLazyQuery } from '@apollo/client';

import { qualityReturnReceiptsQuery } from './gql';
import { IQueryResult, IReturnReceiptVariables } from './interfaces';

export const useQualityReturnReceiptsGql = () => {
  const [runQualityReturnReceiptsGql, { loading, data, error }] = useLazyQuery<IQueryResult, IReturnReceiptVariables>(
    qualityReturnReceiptsQuery,
    {
      context: {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      },
      fetchPolicy: 'network-only'
    }
  );

  return {
    runQualityReturnReceiptsGql,
    loadingQualityReturnReceipts: loading,
    dataQualityReturnReceipts: data?.qualityReturnReceipts || [],
    errorQualityReturnReceipts: error
  };
};
